<template>
    <div v-if="!disabled" id="confirm_send_email_wrapper">
        <el-row>
            <el-row id="confirm_send_email_title_wrapper" class="row">
                <el-button @click="backToMyPage" id="back_button"><i class="el-icon el-icon-arrow-left"></i></el-button>
                <h1 id="confirm_send_email_title">{{$t('changeEmail.confirmSendEmailTitle')}}</h1>
            </el-row>
        </el-row>

        <el-row id="confirm_send_email_description_wrapper">
            <div class="row" style="">
                <p id="email_confirm_was_send_to">{{$t('changeEmail.emailConfirm')}}</p>
                <p id="changed_email">{{changedEmail}}</p>
                <p id="send_to">{{$t('changeEmail.sendTo')}}</p>
            </div>
            <p id="please_visit_email_notification">{{$t('changeEmail.pleaseVisitLinkNotification')}}</p>
        </el-row>

        <el-row id="back_to_my_page_button_wrapper" >
            <el-button id="back_to_my_page_button" @click="backToMyPage">{{$t("changeEmail.backToMyPageButton")}}</el-button>
        </el-row>

    </div>

</template>

<script>
    export default {
        name: "ConfirmSendEmail",

        data() {
            return {
                disabled: true,
                changedEmail: "hoangnv@rabiloo.com",
            }
        },

        created() {
            this.disabled = true;
        },

        methods: {
            backToMyPage() {
                this.$router.push({path: "/myPage"})
            }
        }
    }
</script>

<style scoped lang="scss">
    #back_button:hover {
        background-color: white;
    }

    #back_button{
        font-size: 30px;
        border: none;
        width: 10%;
        text-align: left
    }

    #confirm_send_email_title_wrapper{
        margin-right: 7%;
        margin-left: 7%
    }

    #confirm_send_email_title{
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        width: 80%;
        margin-right: 10%
    }

    #confirm_send_email_description_wrapper{
        margin-right: 10%;
        margin-left: 20%;
    }

    #confirm_send_email_wrapper{
        width: 60%;
        margin-left: 20%;
        margin-right: 20%
    }

    #back_to_my_page_button_wrapper{
        margin-top: 15px;
        text-align: center;
        width: 100%
    }

    #back_to_my_page_button{
        width: 40%
    }

    #changed_email{
        font-weight: bold;
        margin-right: 5px
    }

    #email_confirm_was_send_to{
        margin-right: 5px;
    }

    #please_visit_email_notification{
        font-weight: normal
    }

    #email_confirm_was_send_to{
        margin-top: 0px;
        margin-bottom: 0px;
    }

    #changed_email{
        margin-top: 0px;
        margin-bottom: 0px;
    }

    #send_to{
        margin-top: 0px;
        margin-bottom: 0px;
    }

    @media only screen and (max-width: 1024px) {
        #confirm_send_email_wrapper {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }
    }

    @media only screen and (max-width: 450px){
        #confirm_send_email_wrapper{
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }

        #confirm_send_email_title_wrapper{
            margin-right: 0%;
            margin-left: 0%
        }

        #confirm_send_email_description_wrapper{
            margin-right: 0%;
            margin-left: 0%;
        }

        #confirm_send_email_title{
            font-weight: bold;
            font-size: 100%;
            text-align: center;
            width: 75%;
            float: right;
        }

        #back_button {
            width: 10%;
            text-align: left!important;
            float: left;
            font-size: 100%;
        }

        #back_to_my_page_button{
            width: 100%;
        }

        #email_confirm_was_send_to{
          font-size: 90%;
        }

        #changed_email{
            font-size: 90%;
        }

        #send_to{
            font-size: 90%;
        }

        #please_visit_email_notification{
            font-size: 90%;
        }
    }

</style>